export const defineStyles = (styles, props) => {
    if (!styles) return {}

    return Object.keys(styles).reduce((elements, element) => {
        return { ...elements, [element]: Object.keys(styles[element]).reduce((allStyles, prop) => {
            let value = typeof props[prop] == 'boolean' ? (props[prop] ? 0 : 1) : props[prop] || 'base'

            return { ...allStyles, [prop]: styles[element][prop][value] }
        }, {}) }
    }, '')
}

export const getStyle = (styles, element, props = []) => {
    if (!styles || !styles[element]) return ''

    return Object.entries(styles[element]).filter(p => props.length == 0 || props.includes(p[0])).map(e => e[1]).join(' ')
}